import {gql, useMutation} from "@apollo/client";
import {useAppSelector} from "../redux/hooks";
import {GET_LEVELS_GQL} from "./useGetLevels";

const DELETE_TASK_MUTATION = gql`mutation deleteLevel($auth: String!, $levelId: Int!) {
    deleteLevel(authToken: $auth, levelId: $levelId)
    }`

interface DeleteLevelVariables {
    auth: string,
    levelId: number
}

interface DeleteLevelReturn {
    deleteLevel: number
}

export enum DeleteLevelStatus {
    OK,
    NO_RIGHT,
    TASKS_REMAINING,
    UNKNOWN
}

export default function useDeleteLevel() {
    const [deleteLevel] = useMutation<DeleteLevelReturn, DeleteLevelVariables>(DELETE_TASK_MUTATION, {
        refetchQueries: [GET_LEVELS_GQL]
    })
    const auth = useAppSelector(s => s.auth.authKey)
    const levelId = useAppSelector(s => s.levels.currentLevel?.levelId as number)

    return () => {
        return deleteLevel({variables: { levelId: levelId, auth: auth}}).then(r => {
            if(r.errors) {
                const e = r.errors[0]
                const emesg = e.toString()
                if (emesg.includes("INVCOM")) {
                    return DeleteLevelStatus.NO_RIGHT
                } else if(emesg.includes("NEMPTASK")) {
                    return DeleteLevelStatus.TASKS_REMAINING
                }
                return DeleteLevelStatus.UNKNOWN
            }
            if(r.data) {
                if(r.data.deleteLevel !== null) {
                    return DeleteLevelStatus.OK
                } else {
                    return DeleteLevelStatus.UNKNOWN
                }
            } else {
                return DeleteLevelStatus.UNKNOWN
            }
        }).catch(e => {
            const emesg = e.toString()
            if (emesg.includes("INVCOM")) {
                return DeleteLevelStatus.NO_RIGHT
            } else if(emesg.includes("NEMPTASK")) {
                return DeleteLevelStatus.TASKS_REMAINING
            }
            return DeleteLevelStatus.UNKNOWN
        })
    }
}